import React from 'react';

interface CompanyAddressProps {
  formData: any;
  handleChange: (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>) => void;
}

export const CompanyAddress: React.FC<CompanyAddressProps> = ({ formData, handleChange }) => {
  return (
    <div className="form-section">
      <h3>Address</h3>
      <div className="form-grid">
        <div className="form-group">
          <label htmlFor="address_street">Street Address</label>
          <input
            type="text"
            id="address_street"
            name="address_street"
            value={formData.address_street}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="address_postcode">Postal Code</label>
          <input
            type="text"
            id="address_postcode"
            name="address_postcode"
            value={formData.address_postcode}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="address_city">City</label>
          <input
            type="text"
            id="address_city"
            name="address_city"
            value={formData.address_city}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="address_state">State/Province</label>
          <input
            type="text"
            id="address_state"
            name="address_state"
            value={formData.address_state}
            onChange={handleChange}
            className="form-control"
          />
        </div>
        <div className="form-group">
          <label htmlFor="address_country">Country</label>
          <input
            type="text"
            id="address_country"
            name="address_country"
            value={formData.address_country}
            onChange={handleChange}
            className="form-control"
          />
        </div>
      </div>
    </div>
  );
};